import { styled } from "@mui/material/styles";

import { inkColor, paperColor } from "~/styles/redesignColors";

export const Root = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 10,
});

export const Formats = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: 6,
});

export const FormatChip = styled("button")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
  height: 30,
  padding: "0 12px",
  border: `1px solid ${inkColor(theme)}`,
  borderRadius: 999,
  backgroundColor: inkColor(theme),
  color: paperColor(theme),
  fontFamily: "inherit",
  fontSize: 12,
  fontWeight: 600,
  whiteSpace: "nowrap",
  cursor: "pointer",

  "& svg": {
    fontSize: 16,
  },
}));
